/**
 * Narrows a value to a member of an enum by checking it against the enum's
 * runtime values. For a value typed wider than the enum (a vendor field typed
 * `string`, a mapper parameter typed `VendorStatus | string`), this lets a
 * comparison or `switch` run on the enum type without a cast:
 *
 *   switch (isEnumValue(VendorStatus, status) ? status : undefined) { ... }
 *
 * keeps every input's outcome: a known value takes its `case`, anything else
 * reaches `default`, exactly as the unguarded `switch` did.
 *
 * Numeric enums carry a reverse mapping (`0: 'NAME'`) in their runtime object;
 * those entries are skipped, so a numeric enum accepts its numbers only and
 * never its member names.
 */
export const isEnumValue = (enumObject, value) => Object.entries(enumObject).some(([key, member]) => member === value && !/^\d+$/.test(key));
//# sourceMappingURL=isEnumValue.js.map